export default __webpack_public_path__ + "c01d63d63c3f0fc756ca4e40b74b2727.svg";